import styles from '../InputField/styles.module.scss'
import Dropdown from '@components/ui/formElements/Dropdown'
import { SetSelectionArgs } from '@components/ui/formElements/Dropdown/List'
import { useFormContext } from 'react-hook-form'
import { InputErrorMessage } from '../InputField/InputErrorMessage'

export default function SelectField({
  variant = 'default',
  list,
  label,
  selectedValue,
  id,
  defaultValue,
  required,
  handleSelectOption
}: {
  variant?: 'default' | 'reverse'
  list: readonly {
    label: string
    value: string | number
    availability?: boolean
  }[]
  selectedValue: string | number
  label?: string
  id: string
  required?: boolean
  defaultValue: string
  handleSelectOption: (args: SetSelectionArgs) => void
}) {
  const {
    formState: { errors }
  } = useFormContext()

  return (
    <>
      <label className={styles.InputField} aria-labelledby={id}>
        <span className={`${required ? styles.InputField__required : ''}`}>
          {label}
        </span>
        <Dropdown
          variant={variant}
          list={list}
          id={id}
          defaultValue={defaultValue}
          selection={selectedValue}
          setSelection={handleSelectOption}
          renderItem={item => (
            <span className={styles.InputField__item}>
              {item.flag}
              <span>{item.label}</span>
            </span>
          )}
        />
        {errors && <InputErrorMessage name={id} errors={errors} />}
      </label>
    </>
  )
}
